/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type GenerateOtpInput = {
    id: string;
};
export type apiGenerateOtpMutationVariables = {
    input: GenerateOtpInput;
};
export type apiGenerateOtpMutationResponse = {
    readonly generateOtp: {
        readonly unit: {
            readonly id: string;
            readonly otp: number | null;
        };
    };
};
export type apiGenerateOtpMutation = {
    readonly response: apiGenerateOtpMutationResponse;
    readonly variables: apiGenerateOtpMutationVariables;
};



/*
mutation apiGenerateOtpMutation(
  $input: GenerateOtpInput!
) {
  generateOtp(input: $input) {
    unit {
      id
      otp
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateOtpPayload",
    "kind": "LinkedField",
    "name": "generateOtp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Unit",
        "kind": "LinkedField",
        "name": "unit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otp",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiGenerateOtpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiGenerateOtpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f5aebf9348dcd3ceb1b9385b12b7844",
    "id": null,
    "metadata": {},
    "name": "apiGenerateOtpMutation",
    "operationKind": "mutation",
    "text": "mutation apiGenerateOtpMutation(\n  $input: GenerateOtpInput!\n) {\n  generateOtp(input: $input) {\n    unit {\n      id\n      otp\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '4bda2b0fc52390ecd44543728808fa9e';
export default node;
